<!-- eslint-disable prefer-template -->
<!--
 * @Description: 图片上传组件
 * @Author: Neo
 * @Date: 2019-12-11
 * @LastEditTime: 2021-11-17
 * @LastEditors: Neo
-->
<template>
  <div class="uploadWrapper">
    <vuedraggable
      class="vue-draggable"
      :class="{ single: isSingle, maxHidden: isMaxHidden }"
      v-model="imgList"
      tag="ul"
      draggable=".draggable-item"
      @start="onDragStart"
      @end="onDragEnd"
    >
      <!-- 拖拽元素 -->
      <li
        v-for="(item, index) in imgList"
        :key="item + index"
        class="draggable-item"
        :style="{ width: width + 'px', height: height + 'px' }"
      >
        <el-image
          :src="item.thumburl"
          :preview-src-list="[item.url]"
          @click.stop="handleClickItem"
        ></el-image>

        <div class="shadow" @click="onRemoveHandler(index)">
          <i class="el-icon-delete"></i>
        </div>
      </li>
      <!-- 上传按钮 -->
      <!--
        action="https://httpbin.org/post"
 -->

      <el-upload
        slot="footer"
        ref="uploadRef"
        class="uploadBox"
        :style="{ width: width + 'px', height: height + 'px' }"
        action="/live/uploadCover"
        :headers="headers"
        :with-credentials="true"
        accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
        :show-file-list="false"
        :multiple="!isSingle"
        :limit="limit"
        :data="imgUploadPreFixData"
        :before-upload="beforeUpload"
        :on-success="onSuccessUpload"
        :on-error="onErrorUpload"
        :on-exceed="onExceed"
      >
        <i class="el-icon-plus uploadIcon">
          <span class="uploading" v-show="isUploading">正在上传...</span>
          <span
            v-if="!isUploading && limit && limit !== 99 && !isSingle"
            class="limitTxt"
          >
            最多{{ limit }}张
          </span>
        </i>
      </el-upload>


      <!-- <button @click="test">测试</button> -->
    </vuedraggable>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import vuedraggable from 'vuedraggable' // 一款vue拖拽插件
// import lrz from 'lrz' // 一款图片压缩插件
import utils from './utils'
import { mapState } from 'vuex'

export default {
  name: 'ImgUpload',

  props: {
    // 图片数据(图片url组成的数组) 通过v-model传递
    value: {
      type: Array,
      default() {
        return []
      },
    },
    // 限制上传的图片数量
    limit: {
      type: Number,
      default: 99,
    },
    // 限制上传图片的文件大小(kb)
    size: {
      type: Number,
      default: 10 * 1024,
    },
    // 是否是单图上传(单图上传就是已传图片和上传按钮重叠)
    isSingle: {
      type: Boolean,
      default: false,
    },
    // 是否使用图片压缩
    useCompress: {
      type: Boolean,
      default: false,
    },
    // 图片显示的宽度(px)
    width: {
      type: Number,
      default: 100,
    },
    // 图片显示的高度(px)
    height: {
      type: Number,
      default: 100,
    },

    uploadFixData: {
      type: Object,
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      headers: {},
      isUploading: false, // 正在上传状态
      isFirstMount: true, // 控制防止重复回显

      fileList: [],
      imgUploadPreFixData: {},
    }
  },

  computed: {
    // 图片数组数据
    imgList: {
      get() {
        return this.value
      },
      set(val) {
        if (val.length < this.imgList.length) {
          // 判断是删除图片时同步el-upload数据
          this.syncElUpload(val)
        }
        // 同步v-model
        this.$emit('input', val)
      },
    },
    // 控制达到最大限制时隐藏上传按钮
    isMaxHidden() {
      return this.imgList.length >= this.limit
    },

    ...mapState({
      userInfo: state => state.player.userInfo,
    }),
  },

  watch: {
    value: {
      handler(val) {
        if (this.isFirstMount && this.value.length > 0) {
          this.syncElUpload()
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.value.length > 0) {
      this.syncElUpload()
    }
  },

  components: { vuedraggable },

  methods: {
    // 同步el-upload数据
    syncElUpload(val) {
      const imgList = val || this.imgList
      this.$refs.uploadRef.uploadFiles = imgList.map((v, i) => ({
        name: `pic${i}`,
        url: v,
        status: 'success',
        uid: utils.createUniqueString(),
      }))
      this.isFirstMount = false
    },
    // 上传图片之前
    beforeUpload(file) {
      this.isFirstMount = false
      /*       if (this.useCompress) {
        // 图片压缩
        return new Promise((resolve, reject) => {
          lrz(file, { width: 1920 }).then((rst) => {
            file = rst.file
          })
            .always(() => {
              if (utils.validImgUpload(file, this.size)) {
                this.isUploading = true
                resolve()
              } else {
                reject(new Error())
              }
            })
        })
      } */

      if (utils.validImgUpload(file, this.size)) {
        this.isUploading = true
      }

      console.log(file)

      this.imgUploadPreFixData = Object.assign(
        {
          binaryId: file.name,
          mimeType: file.type,
        },
        this.uploadFixData
      )

      const promise = new Promise((resolve) => {
        this.$nextTick(() => {
          resolve(true)
        })
      })
      return promise
    },
    // 上传完单张图片
    onSuccessUpload(res, file, fileList) {
      if (res.data) {
        if (this.imgList.length < this.limit) {
          this.imgList.push(res.data)
        }
      } else {
        this.syncElUpload()
        Message({ type: 'error', message: res.msg })
      }
      this.isUploading = false
    },

    onErrorUpload(err, file, fileList) {
      console.log(err, file, fileList, '----------')

      this.$notify({
        title: '警告',
        message: `【${file.name}】上传失败,请重试`,
        type: 'warning',
        duration: 60 * 1000,
      })
    },

    // 移除单张图片
    onRemoveHandler(index) {
      this.imgList = this.imgList.filter((v, i) => i !== index)

      // this.$confirm('确定移除该图片?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //   })
      //   .catch(() => {})
    },
    // 超限
    onExceed() {
      this.$refs.uploadRef.abort() // 取消剩余接口请求
      this.syncElUpload()
      Message({
        type: 'warning',
        message: `图片超限，最多可上传${this.limit}张图片`,
      })
    },
    onDragStart(e) {
      e.target.classList.add('hideShadow')
    },
    onDragEnd(e) {
      e.target.classList.remove('hideShadow')
    },

    handleClickItem() {
      const self = this
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        const domImageMaskCloseBtn = document.querySelector('.el-image-viewer__close')
        if (domImageMask) {
          domImageMask.addEventListener('click', self.closeEmit)
        }

        if (domImageMaskCloseBtn) {
          domImageMaskCloseBtn.addEventListener('click', self.closeEmit)
        }
      })
    },

    closeEmit() {
      // 点击遮罩层时调用关闭按钮的 click 事件
      // document.querySelector('.el-image-viewer__close').click();
      this.$emit('viewerClose')
    },

    reset() {
      this.imgList = []
      this.$refs.uploadRef.clearFiles();
    },


    test() {
      console.log(this.imgList)
    }
  },

  beforeDestroy() {
    const self = this
    const domImageMask = document.querySelector('.el-image-viewer__mask')
    const domImageMaskCloseBtn = document.querySelector('.el-image-viewer__close')
    if (domImageMask) {
      domImageMask.removeEventListener('click', self.closeEmit)
    }

    if (domImageMaskCloseBtn) {
      domImageMaskCloseBtn.addEventListener('click', self.closeEmit)
    }
  },
}
</script>

<style lang="stylus" scoped>
/deep/ .el-upload {
  width: 100%;
  height: 100%;
}

// 上传按钮
.uploadIcon {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 20px;
  color: #999;

  .limitTxt, .uploading {
    position: absolute;
    bottom: 10%;
    left: 0;
    width: 100%;
    font-size: 14px;
    text-align: center;
  }
}

// 拖拽
.vue-draggable {
  display: flex;
  flex-wrap: wrap;
  padding: 0;

  .draggable-item {
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    position: relative;
    overflow: hidden;

    .el-image {
      width: 100%;
      height: 100%;
    }

    .shadow {
      position: absolute;
      top: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 0;
      transition: opacity 0.3s;
      color: #fff;
      font-size: 20px;
      line-height: 20px;
      padding: 2px;
      cursor: pointer;
    }

    &:hover {
      .shadow {
        opacity: 1;
      }
    }
  }

  &.hideShadow {
    .shadow {
      display: none;
    }
  }

  &.single {
    overflow: hidden;
    position: relative;

    .draggable-item {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
  }

  &.maxHidden {
    .uploadBox {
      display: none;
    }
  }
}
</style>
